/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import { ReactComponent as LogoImg } from '../../../assets/images/logo.svg'
import { useTranslation } from 'react-i18next'
import printProfitPDF from '../../../utils/printProfitPDF.js'

export default function index() {
  const { t } = useTranslation() || ((text) => text)
  const data = localStorage.getItem('currentprintprofitData')
  const tryToGetData = (data) => {
    try {
      return JSON.parse(data)
    } catch (error) {
      return {}
    }
  }
  const parsedData = tryToGetData(data)

  const { overViewDate, totalServiceCost, totalPatientPay, totalDifference, totalProfit: totalProfitFromData, expenses, selectedCategory, allInputs, allWithdraws, arkaMengjesit = 0, isDayFilter = false } = parsedData || {
    overViewDate: 'N/A',
    totalServiceCost: 0,
    totalPatientPay: 0,
    totalDifference: 0,
    expenses: {},
    selectedCategory: 'all',
    allInputs: 0,
    allWithdraws: 0,
    arkaMengjesit: 0,
    isDayFilter: false
  }

  const { allExpenses, foodExpenses, materialExpenses, otherExpenses, techExpenses } = expenses || {}

  const totalProfit = totalProfitFromData != null ? Number(totalProfitFromData) : (totalPatientPay - allExpenses)
  const currentlyInCachier = parsedData?.currentlyInCachier ?? (allInputs + totalProfit - allWithdraws)

  useEffect(() => {
    if (parsedData) {
      printProfitPDF(parsedData)
    }
  }, [parsedData])

  const adress = 'Rr. Deshmore e Lirise'
  const location = 'Gjakove, Kosove'

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount)
  }

  if (!parsedData || Object.keys(parsedData).length === 0) {
    return (
      <div className={styles.container} style={{ padding: '2rem', textAlign: 'center' }}>
        <p style={{ marginBottom: '1rem' }}>Nuk ka të dhëna për të shtypur. Shtypni &quot;Printo të dhënat&quot; nga faqja e pagesave.</p>
        <a href="/management/payments" style={{ color: '#2BC7BA', fontWeight: 600 }}>Kthehu te Pagesat</a>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div style={{ marginBottom: '1rem', padding: '0.5rem 0' }}>
        <a href="/management/payments" style={{ color: '#2BC7BA', fontWeight: 600, textDecoration: 'none' }}>← Kthehu te Pagesat</a>
      </div>
      <div id='a4_layout' className={styles.a4_layout}>
        <div className={styles.header_container}>
          <div className={styles.header}>
            <div style={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <LogoImg style={{ width: '100%', height: '100%' }} />
            </div>
            <h2 className={styles.web_logo}>Dental Med</h2>
          </div>
          <div className={styles.header_dr_container}>
            <h2 className={styles.adress}>{adress}</h2>
            <p className={styles.location}>{location}</p>
          </div>
        </div>
        <div className={styles.overview_date_header}>
          <h2 className={styles.overview_date_header_text}>
            {t('overview')} {selectedCategory !== 'all' ? `for ${selectedCategory}` : ''}
          </h2>
          <p className={styles.overview_date_header_date}>{overViewDate}</p>
        </div>
        <div className={styles.page_data_container}>
          <div className={styles.expenses_table}>
            <div className={styles.expenses_table_body}>
              <div className={styles.expenses_table_row}>
                <p className={styles.expenses_table_row_text}>{t('food_expenses')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(foodExpenses)}</p>
              </div>
              <div className={styles.expenses_table_row}>
                <p className={styles.expenses_table_row_text}>{t('material_expenses')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(materialExpenses)}</p>
              </div>
              <div className={styles.expenses_table_row}>
                <p className={styles.expenses_table_row_text}>{t('tech_expenses')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(techExpenses)}</p>
              </div>
              <div className={styles.expenses_table_row}>
                <p className={styles.expenses_table_row_text}>{t('other_expenses')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(otherExpenses)}</p>
              </div>
              <div className={styles.expenses_table_row} style={{ fontWeight: 'bold', borderTop: '2px solid #eef2f7', marginTop: '8px' }}>
                <p className={styles.expenses_table_row_text}>{t('total_expenses')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(allExpenses)}</p>
              </div>
            </div>
          </div>
          <div className={styles.rev_table}>
            <div className={styles.expenses_table_body}>
              <div className={styles.expenses_table_row} style={{ fontWeight: 'bold' }}>
                <p className={styles.expenses_table_row_text}>{t('total_service_cost')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(totalServiceCost)}</p>
              </div>
              <div className={styles.expenses_table_row} style={{ fontWeight: 'bold' }}>
                <p className={styles.expenses_table_row_text}>{t('total_patient_pay')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(totalPatientPay)}</p>
              </div>
              <div className={styles.expenses_table_row} style={{ fontWeight: 'bold' }}>
                <p className={styles.expenses_table_row_text}>{t('total_difference')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(totalDifference)}</p>
              </div>
              <div className={styles.expenses_table_row} style={{ borderTop: '2px solid #eef2f7', marginTop: '8px' }}>
                <p className={styles.expenses_table_row_text}>{t('all_inputs')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(allInputs)}</p>
              </div>
              <div className={styles.expenses_table_row}>
                <p className={styles.expenses_table_row_text}>{t('all_withdraws')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(allWithdraws)}</p>
              </div>
              <div className={styles.expenses_table_row} style={{ borderTop: '2px solid #eef2f7', marginTop: '8px', fontWeight: 'bold' }}>
                <p className={styles.expenses_table_row_text}>{t('total_profit')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(totalProfit)}</p>
              </div>
              <div className={styles.expenses_table_row} style={{ fontWeight: 'bold' }}>
                <p className={styles.expenses_table_row_text}>{t('remaining_in_clinic')}</p>
                <p className={styles.expenses_table_row_text}>{formatCurrency(currentlyInCachier)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
